import RootStore from '../../mobx/RootStore';
import { createContext } from 'react';

//add custom validationRules to react-material-ui-form-validator ValidatorForm
import customValidations from '../../common/customValidations';

//remove this library once shared_components library is used instead of components/general
export const storeContext = createContext(RootStore.create());
